import { makeModuleStateSelector } from "@client/content/selectors";
import { createShallowEqualSelector } from "@client/selectors";
import { type UploadEndpointInfo } from "@common/components/Media/Upload/types";
import { defaultState, previewState } from "./reducer";
import { type TicketDetail } from "./types";

export const localStateSelector = makeModuleStateSelector<TicketDetail.AppState>(defaultState, previewState);

export const makeUploadInfoSelector = (withSubpath: boolean) => {
  return createShallowEqualSelector([localStateSelector], (localState): UploadEndpointInfo | null => ({
    isAttachment: true,
    location: "TicketAttachments",
    maxSizeMb: 2,
    subPath: withSubpath ? `/commentAttachments/${localState.detail?.ticketDetail.ticketId}` : undefined
  }));
};
